import React, { useEffect, useState } from "react";
import { Grid, Button, Card, Switch, Paper, Select, MenuItem } from '@material-ui/core';
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { agregarCoseguroExterno, buscarCoseguroExterno, fetchCosegurosExternos, modificarCoseguroExterno } from "../../../../actions/contrataciones/configuraciones/ambCosegurosExternosActions";
import { OBRAS_SOCIALES } from "../../../../utils/constants";
import TableGeneric from "../../../compartidos/abms/TableGeneric";
import moment from "moment";
import { CONFIGURACION_CONTRATOS } from "../../../../utils/permisos";
import { FormIngresoCoseguroExterno } from "./FormIngresoCoseguroExterno";
import ModalAbm from "../../../compartidos/abms/ModalAbm";
import BuscadorAbm from "../../../compartidos/abms/BuscadorAbm";
import AccionesGenericoAbm from "../../../compartidos/abms/AccionesGenericoAbm";
import { TrackingCosegurosExternos } from "./TrackingCosegurosExternos";
import InfoHistorialIcon from "../../../autorizaciones/UI/InfoHistorialIcon";
import { getObrasSociales } from "../../../../actions/afiliado";

const useStyles = makeStyles({
  botonera: {
    padding: 25
  },
  switchBase: {
    color: '#bdbdbd',
    '&$checked': {
      transform: 'translateX(16px)',
      color: '#4CAF50',
      '& + $track': {
        backgroundColor: '#3E8040',
        opacity: 1,
        border: 'none',
      },
    },
  },
  checked: {},
  track: {},
});

export const HomeCosegurosExternos = () => {

  const dispatch = useDispatch();
  const classes = useStyles();
  const { items } = useSelector((state) => state.cosegurosExternos);
  const { obrasSociales = [] } = useSelector((state) => state.obrasSociales);
  const [open, setOpen] = useState(false);
  const [itemForm, setItemForm] = useState(false);

  const [openModalInfo, setOpenModalInfo] = useState(false);
  const [idClave, setIdClave] = useState(false);
  const [descripcion, setDescripcion] = useState(false);
  const [idObraSocial, setIdObraSocial] = useState(OBRAS_SOCIALES.OSOCNA);

  const [openAlta, setOpenAlta] = useState(false);

  useEffect(() => {
    dispatch(fetchCosegurosExternos(idObraSocial));
  }, [dispatch, idObraSocial]);

  useEffect(() => {
    if (obrasSociales.length === 0)
      dispatch(getObrasSociales());
    setIdObraSocial(idObraSocial !== null ? idObraSocial : OBRAS_SOCIALES.OSOCNA);
  }, [dispatch]);

  const handleItemSelect = (item) => {
    setItemForm(item)
    setOpen(true)
  }

  const handleSearch = (textoBuscado) => {
    dispatch(buscarCoseguroExterno(textoBuscado));
  }

  const cerrarModalAlta = () => setOpenAlta(false)

  const cerrarModalModif = () => setOpen(false)

  const handleSave = (item) => {
    const data = {
      idObraSocial: item.idObraSocial,
      descripcion: item.descripcion,
      tope: item.tope,
      defaultCantidad: item.defaultCantidad === 0 || item.defaultCantidad === false ? 0 : 1,
      saltaPago: item.saltaPago,
      fechaDesde: item.fechaDesde,
      valor: item.valor,
      valorExcede: item.valorExcede,
      nuevoPeriodo: item.nuevoPeriodo === null ? false : item.nuevoPeriodo,
      id: item.id,
      idOSGrupo: item.idOSGrupo
    }
    if (item.id) {
      dispatch(modificarCoseguroExterno(data));
      cerrarModalModif();
    } else {
      dispatch(agregarCoseguroExterno(data))
      cerrarModalAlta();
    }


  };



  const handleDelete = (item) => {
    //dispatch(EliminarPlazo(item.id)); 
  }

  const intialValue = {
    idObraSocial: idObraSocial,
    descripcion: "",
    tope: 0,
    defaultCantidad: 0,
    saltaPago: false,
    fechaDesde: moment(),
    //fechaHasta: new Date(3000, 11, 31),
    valor: 0,
    valorExcede: 0,
    nuevoPeriodo: false,
    id: null,
    idOSGrupo: null
  }

  console.log(intialValue)
  return (
    <div>
      {openModalInfo && (
        <TrackingCosegurosExternos
          open={openModalInfo}
          onClose={() => setOpenModalInfo(false)}
          idClave={idClave}
          descripcion={descripcion}
          //tipoTrackingId={TIPO_TRACKING_ABM.GRUPO_COSEGURO}
          showCampo={true}
        />
      )}
      <Grid container justify="center">
        <ModalAbm title="Agregar Coseguro" open={openAlta} setOpen={setOpenAlta}>
          <FormIngresoCoseguroExterno formData={intialValue} idObraSocial={idObraSocial} handleSave={handleSave} cerrarModal={() => setOpenAlta(false)} permisoAlta={CONFIGURACION_CONTRATOS.ALTA} editando={false} />
        </ModalAbm>
        <ModalAbm title="Modificar" open={open} setOpen={setOpen}>
          <FormIngresoCoseguroExterno formData={itemForm} idObraSocial={idObraSocial} handleSave={handleSave} cerrarModal={() => setOpen(false)} permisoEdit={CONFIGURACION_CONTRATOS.MODIFICACION} editando={true} />
        </ModalAbm>
        <Grid item xs={12}>
          <Button variant="contained" color="primary" onClick={() => setOpenAlta(true)} style={{ float: "right", marginTop: "1rem" }}>+ Agregar coseguro</Button>
        </Grid>
        <Grid item xs={12} md={6} style={{paddingRight : 10}}>
          <Paper style={{ padding: 35 }}>
            {Array.isArray(obrasSociales) && obrasSociales.length > 0 && (
              <Select
                fullWidth
                margin="normal"
                label="OS"
                name="idObraSocial"
                value={idObraSocial}
                onChange={(e) => {
                  setIdObraSocial(e.target.value);
                }}
                style={{
                  // width: !props.hideTitle && 500,
                  padding: 6,
                  backgroundColor: "#FAFAFA",
                  borderRadius: "5px",
                }}
              >
                {obrasSociales.filter((ObraSocial) => ObraSocial.idObraSocial !== OBRAS_SOCIALES.OSPEDYC).map((ObraSocial) => (
                  <MenuItem
                    key={ObraSocial.idObraSocial}
                    value={ObraSocial.idObraSocial}
                  >
                    {ObraSocial.siglas} - {ObraSocial.razonSocial}
                  </MenuItem>
                ))}
              </Select>
            )}
          </Paper>
        </Grid>
        <Grid item xs={12} md={6} className={classes.root}>
          <BuscadorAbm title="Buscar ingreso" handleSearch={handleSearch} />
        </Grid>
        <Grid item xs={12} md={9} style={{ marginTop: "2rem" }} >
          <Card>
            <TableGeneric
              data={items}
              columns={[
                {
                  label: "",
                  id: "",
                  sort: false,
                  customBody: (item) => ((moment(item.fechaHasta).format('DD/MM/YYYY') === "31/12/3000") &&
                    <InfoHistorialIcon
                      onClick={() => {
                        setOpenModalInfo(false);
                        setIdClave(item?.idOSGrupo);
                        setDescripcion(`${item?.idOSGrupo} - ${item?.descripcion}`);
                      }}
                    />
                  ),
                },
                {
                  label: "",
                  customBody: (item) => (
                    <AccionesGenericoAbm
                      item={item}
                      handleItemSelect={handleItemSelect}
                      permisoDelete={CONFIGURACION_CONTRATOS.BAJA}
                      handleDelete={handleDelete}
                      showSelect={moment(item.fechaHasta).format('DD/MM/YYYY') === "31/12/3000"}
                      showDelete={false}
                    />
                  )
                },
                {
                  label: "Descripcion grupo",
                  id: "descripcion",
                  sort: true
                },
                {
                  label: "Obra Social",
                  id: "razonSocial",
                  sort: true
                },
                {
                  label: "Tope",
                  id: "tope",
                  sort: true
                },
                {
                  label: "Fecha desde",
                  id: "fechaDesde",
                  sort: true,
                  customBody: (item) => item.fechaDesde ? moment(item.fechaDesde).format('DD/MM/YYYY') : ""
                },
                {
                  label: "Fecha hasta",
                  id: "fechaHasta",
                  sort: true,
                  customBody: (item) => item.fechaHasta ? (moment(item.fechaHasta).format('DD/MM/YYYY') === "31/12/3000" ? "VIGENTE" : moment(item.fechaHasta).format('DD/MM/YYYY')) : ""
                },
                {
                  label: "Valor",
                  id: "valor",
                  sort: true
                },
                {
                  label: "Valor excede",
                  id: "valorExcede",
                  sort: true
                },
                {
                  label: "Marca en asistencia",
                  id: "defaultCantidad",
                  sort: true,
                  customBody: (item) => (
                    <Switch
                      checked={item?.defaultCantidad}
                      value={item?.defaultCantidad}
                      name="defaultCantidad"
                      classes={{ switchBase: classes.switchBase, checked: classes.checked, track: classes.track }}
                    />
                  ),
                },
                {
                  label: "Salta pago",
                  id: "saltaPago",
                  sort: true,
                  customBody: (item) => (
                    <Switch
                      checked={item?.saltaPago}
                      value={item?.saltaPago}
                      name="saltaPago"
                      //onChange={(e) => handleChangeSwitch(e, item)}
                      classes={{ switchBase: classes.switchBase, checked: classes.checked, track: classes.track }}
                    />
                  ),

                },
              ]}
            />
          </Card>
        </Grid>
      </Grid>
    </div>
  )
}